import { getPlatform } from '../utils';

export const sbx = 'sbx.';
export const uat = 'uat.';
export const prod = 'prod.';

let env = sbx;

if (process.env.REACT_APP_API_ENV === 'production') {
  env = '';
}
if (process.env.REACT_APP_API_ENV === 'uat') {
  env = uat;
}

if (getPlatform() !== 'web') {
  env = '__ENVTARGET__.';
}

export const environment = env === '' ? prod : env;

export const typedEnvironment =
  environment === sbx || environment === uat || environment === prod
    ? environment
    : sbx;

const apiV3 = `https://api.${env}solarislens.com/api/v3`;
const apiV4 = `https://api.${env}solarislens.com/api/v4`;

// Analytics
export const enabledAnalytics = process.env.REACT_APP_API_ENV === 'production';

// General User access V3
export const loginEndpointV3 = `${apiV3}/login`;
export const loginSsoEndpointV3 = `${apiV3}/login/sso`;
export const logoutEndpointV3 = `${apiV3}/signout`;
export const refreshEndpointV3 = `${apiV3}/refresh`;
export const userChangePasswordEndpointV3 = `${apiV3}/login/change-pasword`;
export const forgotPasswordEndpointV3 = `${apiV3}/user/password/forgot`;
export const passwordRecoverEndpointV3 = `${apiV3}/user/password/confirm-new-password`;
export const truckingDashboardEndpointV3 = `${apiV3}/dashboards/truck-loads`;
export const truckingLoadsExportEndpointV3 = `${apiV3}/truck-loads/export/csv`;
export const truckingMetricsEndpointV3 = `${apiV3}/truck-loads/metrics`;
export const truckingStatusEndpointV3 = `${apiV3}/truck-loads/status`;
export const truckingCarriersEndpointV3 = `${apiV3}/truck-loads/carriers/totalLoads`;
export const purchaseOrdersV3 = `${apiV3}/orders`;
export const trucksEndpointV3 = `${apiV3}/truck-loads`;
export const trucksEndpointV4 = `${apiV4}/truck-loads`;
export const ordersEndPoint = `${apiV3}/orders/metrics`;
export const truckingSummaryEndpointV3 = `${apiV3}/dashboards/summary`;
export const truckingStageOrderLoads = `${apiV3}/truck-loads/stage/orders/loads`;
export const locationsEndpoint = `${apiV3}/locations`;
export const carriersEndpointV3 = `${apiV3}/companies`;
export const getCompaniesEndPointV3 = `${apiV3}/companies`;
export const truckingIntegrationsEndPoint = `${apiV3}/companies/integrations`;
export const availableLoadsEndpoint = `${apiV3}/truck-loads/stage/orders/summary`;
export const visionCreateProductOrder = `${apiV3}/productorders`;
export const wellSitesCatalogV3 = `${apiV3}/wells/catalog`;
export const wellSummaryEndPointV3 = `${apiV3}/wells/summary`;
export const truckingStageEndpoint = `${apiV3}/truck-loads/stage/orders/loads`;
export const truckingLoadStatusEndPoint = `${apiV3}/truck-loads/status`;
export const controlPlanEndPoint = `${apiV3}/controlplan`;
export const wellSiteEventEndPointV3 = `${apiV3}/well-site-events`;
export const wellSiteEventRulesEndPointV3 = `${apiV3}/well-site-events/stages/rules`;
export const visionProductCatalog = `${apiV3}/fleets-management/products`;
export const wellsitesListV3 = `${apiV3}/wells/cardview`;
export const favoritesEndpointV3 = `${apiV3}/fleets-management/users/preferences/favorites/wells`;
export const configurationEndpointV3 = `${apiV3}/configurations`;
export const errorMessagesEndpointV3 = `${apiV3}/fleets-management/fleets/errors`;
export const wellStatusEndpointV3 = `${apiV3}/fleets/event`;
export const gWellSiteCompletedJobsV3 = `${apiV3}/wellsites/completedjobs`;
export const gWellSiteCompletedJobsCompaniesV3 = `${apiV3}/wellsites/completedjobs/companies`;
export const getFleetsSiteOpsEndpointV3 = `${apiV3}/wells/site-ops`;
export const updateFleetsSiteOpsEndpointV3 = `${apiV3}/wells/site-ops`;
export const loadCellsV3 = `${apiV3}/load-cells`;
export const gLoadCellsHistoryV3 = `${apiV3}/load-cells/history`;
export const sLoadCellsHistoryV3 = `${apiV3}/load-cells/history`;
export const dLoadCellsHistoryV3 = `${apiV3}/load-cells/history`;
export const getLodingFacilitiesEndpointV3 = `${apiV3}/facilities`;
export const truckingFacilitiesEndpointV3 = `${apiV3}/facilities/catalog`;
export const wellHistoryExportEndPointEmailV3 = `${apiV3}/fleets/history/email`;
export const fleetsDashboardEndpoint = `${apiV3}/fleets/dashboard-status`;
export const drivesEndpoint = `${apiV3}/drives`;
export const drivesHistoricalEndpoint = `${apiV3}/drives/history`;
export const gensetsEndpoint = `${apiV3}/storage/components/gensets`;
export const bolPicture = `${apiV4}/truck-loads/bol`;
export const driverLoadsEndpoint = `${apiV4}/truck-loads/my-loads`;
export const techToolEndpoint = `${apiV4}/files/tech-toolbox`;

// General User access

export const webSocketTrucking = `wss://api.${env}solarislens.com/api/v2/ws`;
export const webSocketTruckloadsV5 = `wss://api.${env}solarislens.com/api/v5/ws-truckloads`;
export const webSocketLoadCells = `wss://api.${env}solarislens.com/api/v2/wsloadcellsevent`;
export const webSocketFleetEvent = `wss://api.${env}solarislens.com/api/v2/wsfleetevent`;
export const webSocketCardView = `wss://api.${env}solarislens.com/api/v2/wscardview`;
export const webSocketMetrics = `wss://api.${env}solarislens.com/api/v2/ws`;
export const webSocketDrives = `wss://api.${env}solarislens.com/api/v3/wsdrives`;
export const webSocketFleetStatusDashboard = `wss://api.${env}solarislens.com/api/v3/wsfleetstatusdashboardevent`;
export const webSocketComponents = `wss://api.${env}solarislens.com/api/v3/wscomponents`;
export const webSocketInstalledProducts = `wss://api.${env}solarislens.com/api/v4/ws-installed-products`;
export const notificationsEndpoint = `${apiV3}/user-profiles`;
export const userProfileEndpoint = `${apiV3}/user-profiles`;

// Admin access V3
export const driverProfileEndpoint = `${apiV3}/user-profiles`;
export const userProfileEndpointV3 = `${apiV3}/user/profile`;
export const getUsersEndPointV3 = `${apiV3}/users/profiles`;
export const getGroupsEndPointV3 = `${apiV3}/users/groups`;
export const createUserEndPointV3 = `${apiV3}/signup`;
export const deleteUserEndPointV3 = `${apiV3}/user`;
export const updateUserEndPointV3 = `${apiV3}/user`;
export const getUserProfilesSearchEndPointUsersV3 = `${apiV3}/user-profiles`;
export const getGroupsEndPointUsersV3 = `${apiV3}/user-profiles/users/groups`;
export const createUserEndPointUsersV3 = `${apiV3}/user-profiles/signup`;
export const updateUserEndPointUsersV3 = `${apiV3}/user-profiles/user`;
export const deleteUserEndPointUsersV3 = `${apiV3}/user-profiles/user`;
export const disableUserEndPointV3 = `${apiV3}/user/disable`;
export const enableUserEndPointV3 = `${apiV3}/user/enable`;
export const addUserToGroupEndPointV3 = `${apiV3}/user-profiles/group/add`;
export const updateUserGroupEndPointV3 = `${apiV3}/user-profiles/group/replace`;
export const rmvUserToGroupEndPointV3 = `${apiV3}/user-profiles/group/delete`;
export const serviceMaxSyncEndpointV3 = `${apiV3}/work-orders`;
export const jobsEndPointV3 = `${apiV3}/jobs`;
export const jobsSummaryEndPointV3 = `${apiV3}/jobs/summary`;
export const jobsExportEndPointV3 = `${apiV3}/jobs/export`;
export const jobsExportPayloadEndPointV3 = `${apiV3}/jobs/export/payload`;
export const getFleetsEndpointV3 = `${apiV3}/storage/fleets`;
export const createFleetEndpointV3 = `${apiV3}/storage/fleets`;
export const fleetAccessLevelsEndpointV3 = `${apiV3}/fleets-management/fleets`;
export const fleetAccessLevelsWellNameEndpointV3 = `${apiV3}/fleets-management/wellsite`;
export const fleetStatusEndpointV3 = `${apiV3}/fleets-management/fleets/status`;
export const wellHistoryEndPointV3 = `${apiV3}/fleets/history`;
export const wellHistoryWebExportEndPointV3 = `${apiV3}/fleets/history/download`;
export const wellSiteDetailsEndPointV3 = `${apiV3}/wells`;
export const openTicketSyncV4 = `${apiV4}/openticket/send`;
export const installedProductsV4 = `${apiV4}/installed-products`;
export const getDriverProfileV3 = `${apiV3}/user-profiles/me`;
export const getLocationsEndpointV3 = `${apiV3}/locations/category/powersite`;
export const notificationConfigV4 = `${apiV4}/notification-config`;
